if (!customElements.get('share-button')) {
  customElements.define(
    'share-button',
    class ShareButton extends HTMLElement {
      connectedCallback() {
        this.syncHrefs();
        const copyBtn = this.querySelector('.share-button__copy');
        if (copyBtn && navigator.clipboard) {
          copyBtn.addEventListener('click', this._onCopyClick.bind(this));
        }
      }

      syncHrefs() {
        const url = this.dataset.shareUrl;
        if (!url) return;

        const title = this.dataset.shareTitle || document.title;
        const media = this.dataset.shareMedia || '';
        const enc = encodeURIComponent;

        const fb = this.querySelector('.share-button__link--facebook');
        if (fb) fb.href = `https://www.facebook.com/sharer.php?u=${enc(url)}`;

        const tw = this.querySelector('.share-button__link--twitter');
        if (tw) tw.href = `https://twitter.com/intent/tweet?url=${enc(url)}&text=${enc(title)}`;

        const li = this.querySelector('.share-button__link--linkedin');
        if (li) li.href = `https://www.linkedin.com/sharing/share-offsite/?url=${enc(url)}`;

        const pi = this.querySelector('.share-button__link--pinterest');
        if (pi) {
          let href = `https://pinterest.com/pin/create/button/?url=${enc(url)}&description=${enc(title)}`;
          if (media) href += `&media=${enc(media)}`;
          pi.href = href;
        }

        const em = this.querySelector('.share-button__link--email');
        if (em) {
          const body = `${title}\n\n${url}`;
          em.href = `mailto:?subject=${enc(title)}&body=${enc(body)}`;
        }
      }

      _onCopyClick(event) {
        const btn = event.currentTarget;
        const url = this.dataset.shareUrl;
        if (!url) return;

        navigator.clipboard.writeText(url).then(() => {
          const success = window.accessibilityStrings?.shareSuccess || '';
          if (success) btn.setAttribute('aria-label', success);
          window.setTimeout(() => {
            const def = btn.getAttribute('data-default-label');
            if (def) btn.setAttribute('aria-label', def);
          }, 2500);
        });
      }

      updateUrl(url) {
        this.dataset.shareUrl = url;
        this.syncHrefs();
      }
    }
  );
}
